<div class="d-flex justify-content-center">
  <div class="app-button-container app-flex app-flex-middle">
    <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
      <span class="app-key app-key-unimportant">{{ decisionKeys[0] }}</span>
      <button value="unimportant" class="app-btn app-btn-hov-green" (click)="triggerDecision(0)">
        {{ keyLabels[0] | titlecase }}
      </button>
    </div>
    <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
      <span class="app-key app-key-unimportant">{{ decisionKeys[1] }}</span>
      <button value="unimportant" class="app-btn app-btn-hov-green" (click)="triggerDecision(1)">
        {{ keyLabels[1] | titlecase }}
      </button>
    </div>
    <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
      <span class="app-key app-key-unimportant">{{ decisionKeys[2] }}</span>
      <button value="unimportant" class="app-btn app-btn-hov-green" (click)="triggerDecision(2)">
        {{ keyLabels[2] | titlecase }}
      </button>
    </div>
    <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
      <span class="app-key app-key-unimportant">{{ decisionKeys[3] }}</span>
      <button value="unimportant" class="app-btn app-btn-hov-green" (click)="triggerDecision(3)">
        {{ keyLabels[3] | titlecase }}
      </button>
    </div>
  </div>
</div>
